import ArrowAI from '../icons/ArrowAI'

export const DefaultFooter = () => {
  return (
    <footer className="fixed bottom-2 right-3 w-fit p-1 md:p-2">
      <div className="flex items-center justify-end">
        <div className="mr-2 text-sm text-gray-500">
          <ArrowAI />
        </div>
      </div>
    </footer>
  )
}
